import { Modal } from 'antd';
import { t } from 'i18next';
import { useEffect } from 'react';

import IconSuccess from '../../../assets/Images/icons/icon-success';

const ModalSuccess = ({
    open,
    text = 'Successfully saved data.',
    handelClose,
}) => {
    useEffect(() => {
        setTimeout(() => handelClose(), 2000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            closable={false}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                <IconSuccess />
                <div className="text-2xl font-semibold">
                    {t('common.Success')}
                </div>
                <div>{text}</div>
            </div>
        </Modal>
    );
};
export default ModalSuccess;
